import {triggerWindowResize} from '../helpers';

export default class AjaxFormComponent {
  static CLASSES = {
    AJAX_FORM: 'ajax-form',
    AJAX_FORM_PROCESSING: 'ajax-form--processing',
    BODY: 'ajax-form__body',
    FIELD: 'field',
    FIELD_COMPLETE: 'is-valid',
    FIELD_ERROR: 'is-invalid',
    FIELD_MESSAGE: 'field__message',
    MESSAGE: 'ajax-form__message',
    MESSAGE_SUCCESS: 'ajax-form__message--success',
    MESSAGE_ERROR: 'ajax-form__message--error'
  };

  static init($form) {
    if (!$form || $form.ajaxFormComponent) {
      return;
    }

    $form.ajaxFormComponent = new AjaxFormComponent($form);
  }

  static initAll() {
    document.querySelectorAll(`.${AjaxFormComponent.CLASSES.AJAX_FORM}`).forEach(($form) => {
      AjaxFormComponent.init($form);
    });
  }

  constructor($form) {
    this.$form = $form;
    this.$body = $form.querySelector(`.${AjaxFormComponent.CLASSES.BODY}`);
    this.$message = $form.querySelector(`.${AjaxFormComponent.CLASSES.MESSAGE}`);

    this.onSubmit = this.onSubmit.bind(this);

    this.init();
  }

  init() {
    this.$form.addEventListener('submit', this.onSubmit);
    this.$form.querySelectorAll(`input,textarea,select`).forEach(($input) => {
      $input.addEventListener('change', AjaxFormComponent.onChange);
      $input.addEventListener('input', AjaxFormComponent.onChange);
      $input.addEventListener('keyup', AjaxFormComponent.onChange);
    });
  }

  destroy() {
    this.$form.removeEventListener('submit', this.onSubmit);
    this.$form.ajaxFormComponent = null;
  }

  onSubmit(event) {
    event.preventDefault();
    this.send();
  }

  static onChange(event) {
    AjaxFormComponent.validate(event.target);
  }

  static validate($input) {
    if (!$input.value.length) {
      var $field = $input.parentElement;
      $field.classList.remove(AjaxFormComponent.CLASSES.FIELD_ERROR);
      $field.classList.remove(AjaxFormComponent.CLASSES.FIELD_COMPLETE);
    } else {
      if ($input.checkValidity()) {
        AjaxFormComponent.hideError($input);
      } else {
        AjaxFormComponent.showError($input);
      }
    }
  }

  static showError($input, message) {
    var $field = $input.parentElement;
    var $error = $field.querySelector(`.${AjaxFormComponent.CLASSES.FIELD_MESSAGE}`);
    var errorText = message || $input.validationMessage;
    $input.classList.remove(AjaxFormComponent.CLASSES.FIELD_COMPLETE);
    $input.classList.add(AjaxFormComponent.CLASSES.FIELD_ERROR);

    if (!$error) {
      $error = document.createElement('div');
      $error.className = AjaxFormComponent.CLASSES.FIELD_MESSAGE;
      $error.textContent = errorText;
      $error.hidden = false;

      $field.appendChild($error);
    } else {
      $error.textContent = errorText;
      $error.hidden = false;
    }
  }

  static hideError($input) {
    var $field = $input.parentElement;
    var $error = $field.querySelector(`.${AjaxFormComponent.CLASSES.FIELD_MESSAGE}`);
    $input.classList.remove(AjaxFormComponent.CLASSES.FIELD_ERROR);
    $input.classList.add(AjaxFormComponent.CLASSES.FIELD_COMPLETE);

    if ($error) {
      $error.textContent = '';
      $error.hidden = true;
    }
  }

  isProcessing() {
    return this.$form.classList.contains(AjaxFormComponent.CLASSES.AJAX_FORM_PROCESSING);
  }

  setProcessing(flag) {
    this.$form.classList.toggle(AjaxFormComponent.CLASSES.AJAX_FORM_PROCESSING, flag);
  }

  send() {
    if (this.isProcessing()) {
      return Promise.resolve();
    }

    this.setProcessing(true);

    let fetchOptions = {
      method: this.$form.method
    };

    if (this.$form.method.match(/POST|PUT|PATCH/i)) {
      fetchOptions.body = new FormData(this.$form);
    }

    fetch(this.$form.action, fetchOptions)
      .then((response) => {
        this.setProcessing(false);

        return response.json();
      })
      .then((json) => {
        /**
         * json = {
         *   success: boolean,
         *   message: string,
         *   errors: [],
         * }
         */

        if (!json) {
          return;
        }

        if (json.success) {
          this.$body.style.display = 'none';
          this.$message.classList.remove(AjaxFormComponent.CLASSES.MESSAGE_ERROR);
          this.$message.classList.add(AjaxFormComponent.CLASSES.MESSAGE_SUCCESS);
          this.$message.style.display = 'block';
          this.$message.innerText = json.message;

          triggerWindowResize();
        } else {
          if (json.errors) {
            Object.keys(json.errors).forEach((fieldName) => {
              var errorText = json.errors[fieldName];
              var $input = this.$form.querySelector(`[name="${fieldName}"]`);
              AjaxFormComponent.showError($input, errorText);
            });
          }
          this.$message.classList.remove(AjaxFormComponent.CLASSES.MESSAGE_SUCCESS);
          this.$message.classList.add(AjaxFormComponent.CLASSES.MESSAGE_ERROR);
          this.$message.style.display = 'block';
          this.$message.innerText = json.message;
        }
      })
      .catch(() => {
        this.setProcessing(false);
      });
  }
}
